import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export const EmptyState = ({ icon: Icon, title, description, actionLabel, actionTo, onAction, className, testId = "empty-state" }) => (
  <div className={cn("rounded-xl border bg-card p-10 text-center", className)} data-testid={testId}>
    {Icon ? (
      <div className="mx-auto mb-4 h-12 w-12 rounded-xl bg-accent text-accent-foreground flex items-center justify-center">
        <Icon className="h-6 w-6" />
      </div>
    ) : null}
    <h3 className="text-lg font-semibold">{title}</h3>
    {description ? <p className="mt-1 text-sm text-muted-foreground max-w-md mx-auto">{description}</p> : null}
    {actionLabel ? (
      <div className="mt-5">
        {actionTo ? (
          <Button asChild data-testid="empty-state-action">
            <Link to={actionTo}>{actionLabel}</Link>
          </Button>
        ) : (
          <Button onClick={onAction} data-testid="empty-state-action">
            {actionLabel}
          </Button>
        )}
      </div>
    ) : null}
  </div>
);
